import { UserRole } from "@/uses/useUserRoles";

export default function useUserRolesFormatter() {
  return {
    formatUserRoles(roles?: UserRole[]) {
      if (roles) {
        return roles.join(", ");
      }
      return "";
    },
  };
}
